import axios from 'axios';
import { apiPath, iconsApiPath, searchApiPath } from './api.config';
import { IconModel } from '@app/models/Icon/Icon.model';
import { IconApiResponse, IconResponse } from '@app/models/Icon/Icon.interface';

declare global {
  interface Window {
    yaCounter32628510: {
      hit: Function;
      params: Function;
    };
    Spatz: {
      addYaCounter: (
        id: number,
        counterOptions: {
          clickmap: boolean;
          trackLinks: boolean;
          accurateTrackBounce: boolean;
          webvisor: boolean;
          trackHash: boolean;
        },
        scriptOptions: {
          initOnly: boolean;
        }
      ) => void;
      send: (
        schema: {
          type?: string;
          src?: string;
          data: Record<string, unknown>;
        },
        counters?: {
          yandex: boolean;
          mosStats: boolean;
        }
      ) => void;
    };
  }
}

let axiosConfig = {
  headers: {
    'x-caller-id': 'catalogue-public-app',
  },
};

const createIconsArray = (items: Array<IconResponse>) => {
  return items.map((item) => new IconModel(item));
};

export async function getIcons() {
  let icons: Array<IconModel> = [];
  let page = 1;
  let pageCount = 1;
  const filter = { category: 'catalog' };
  try {
    while (page <= pageCount) {
      const data = await (axios
        .get(
          `${iconsApiPath}?page=${page}&filter=${JSON.stringify(filter)}`,
          axiosConfig
        )
        .then((response) => response.data) as unknown as IconApiResponse);
      if (data?.items?.length) {
        icons = icons.concat(createIconsArray(data.items));
      }
      pageCount = data?._meta?.pageCount;
      page++;
    }
  } catch (error) {
    console.error(error);
  }
  return icons;
}

export async function getCatalogueByRoute(route?: string) {
  let newRoute = route;
  if (newRoute!.charAt(newRoute!.length - 1) === '/')
    newRoute = newRoute!.substr(0, newRoute!.length - 1);
  return axios.get(`${apiPath}${newRoute}/`, axiosConfig).then((response) => {
    return response.data;
  });
}

export async function getCatalogueElement(
  catalogueType: 'biznes' | 'uslugi',
  elementId: number
) {
  return axios
    .get(`${apiPath}/${catalogueType}/${elementId}/`, axiosConfig)
    .then((response) => {
      return response.data;
    });
}

export async function searchSuggestions(
  query: string,
  perPage: number = 6,
  page?: number
) {
  return axios
    .get(
      `${searchApiPath}?q=${encodeURIComponent(
        query + '*'
      )}&pagesize=${perPage}&simple_query_string=1&skip_stat=8${
        page ? `&page={page}` : ''
      }`
    )
    .then((response) => {
      return response.data;
    });
}

export async function sendRouteChange({
  url,
  title,
  referer,
}: {
  url: string;
  title: string;
  referer: string;
}) {
  if (window.yaCounter32628510)
    return window.yaCounter32628510.hit(url, {
      title,
      referer,
    });
}
